export const searchContainer = {
    padding: '70px 0',
    '@media(min-width: 0px) and (max-width:767px)': {
        padding: '40px 0'
    }
};
export const searchContainerDropdown = {
    padding: '25px 0',
    '@media(min-width: 0px) and (max-width:767px)': {
        padding: '20px 0'
    }
};
export const searchH2 = {
    textAlign: 'center',
    color: '#003755',
    font: '500 2.75em Danske Human',
    '@media(min-width: 0px) and (max-width:767px)': {
        font: '500 2.25em Danske Human'
    }
};
export const searchInputContiner = {
    margin: '20px auto 0',
    width: '35%',
    '@media(min-width: 0px) and (max-width:767px)': {
        width: '75%'
    }
};

export const closeIcon = {
    position: 'absolute',
    top: '63%',
    right: '565px',
    transform: 'translateY(-50%)',
    fontSize: '20px',
    color: '#007BC7',
    cursor: 'pointer',
    '@media(min-width: 0px) and (max-width:767px)': {
        right: '5px'
    }
};
export const searchInput = {
    width: '85%',
    height: '50px',
    borderRadius: '40px 0 0 40px',
    border: '1px solid #EBEBEB',
    borderRight: '0',
    outline: 'none',
    padding: '0 3%',
    float: 'left',
    '&:focus': {
        transition: 'box-shadow 0.5s, border-color 0.25s ease-in-out',
        // border: '1px solid #009FDA'
        border: '1px solid #007BC7'
    }
};
export const searchIconSection = {
    width: '15%',
    float: 'left',
    backgroundColor: '#007BC7',
    borderRadius: '0 40px 40px 0',
    height: '50px'
};
export const searchIcon = {
    padding: '14px 28%',
    '@media(min-width: 768px) and (max-width:1024px)': {
        padding: '14px 16%',
    }
};


//Jerin
export const searchInputContainerDp = {
    margin: '20px auto 0',
    width: '70%',
    '@media(min-width: 0px) and (max-width:767px)': {
        width: '95%'
    }
};

export const searchRowDp = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const searchBoxDp = {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #EBEBEB',
    borderRadius: '40px',
    width: '70%', // Adjust width to fit search input, dropdown, and search icon
    backgroundColor: '#fff',
};

export const searchInputDp = {
    width: '400px', // Reduced width for smaller search text bar
    height: '50px',
    border: 'none',
    outline: 'none',
    padding: '0 3%',
    borderRadius: '40px 0 0 40px', // Ensure rounded corners on the left
    '&:focus': {
        transition: 'box-shadow 0.5s, border-color 0.25s ease-in-out',
        border: 'none'
    },
    '&:-internal-autofill-selected': {
        backgroundImage: 'none !important',
        backgroundColor: '#fff !important', // Override background color to white
        color: 'fieldtext !important',
    }
};

export const closeIconDp = {
    marginLeft: '10px',
    fontSize: '20px',
    color: '#007BC7',
    cursor: 'pointer',
};

export const dropdownDp = {
    width: '230px', // Reduced width for smaller dropdown
    height: '50px',
    border: 'none',
    backgroundColor: '#fff',
    color: '#495057',
    outline: 'none',
    padding: '0 3%',
    borderRadius: '0', // No border radius to ensure it aligns with the search icon
    '&:focus': {
        color: '#495057',
        borderColor: '#80bdff',
        boxShadow: '0 0 0 .2rem #FFF',
    }
};

export const searchIconSectionDp = {
    width: '60px', // Increased width for search icon section
    height: '50px',
    backgroundColor: '#007BC7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0 40px 40px 0', // Rounded corners on the right
};

export const searchIconDp = {
    width: '24px', // Adjust size to fit within the section
    height: '24px',
};